export default (params) => ({
  trigger: {
    name: 'chatbot.show_error_message',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'show_notification',
      params: {
        sub_feature: 'live_chat',
        type: 'notification_line',
      },
    },
    nonInt: true,
  },
});
